import axios from 'axios';
import {chartInstance} from '../baseApi';
let hostUrl = 'https://chart-api.risingx.io'
export async function getDominanceGuage(){
    try {
        const res = await chartInstance.get(`/analysis/dominance-data`)
        let result = res.data.result[0]
        // console.log(result);
        let {btc,tether,fixed,fluctuating} = result
        return {btc,tether,fixed,fluctuating}
    }catch(err){
        console.error(err);
    }
}

export async function getDominanceLine(id,type){
    try {
        const res = await axios.get(`${hostUrl}/analysis/dominance-line?domi_type=${type}`)
        let result = res.data.result
        // console.log(result);
        return {[id]:result}
    }catch(err){
        console.error(err);
    }
}